import React from 'react';
import {
  shape, arrayOf, string, func,
} from 'prop-types';
import { isEmpty } from 'lodash';
import TableCell from './TableCell';

const TableBody = (props) => {
  const { list, extra, selected } = props;
  return (
    <tbody className="MuiTableBody-root">
      {list && !isEmpty(list) && list.map((cell) => (
        <TableCell
          extra={extra}
          key={`${list.indexOf(cell)}_${cell.sqsId}`}
          onTableRowClick={props.onTableRowClick}
          sourceData={cell}
          className={selected.sqsId === cell.sqsId ? 'tr-active' : ''}
        />
      ))}
    </tbody>
  );
};

TableBody.propTypes = {
  extra: shape().isRequired,
  selected: shape({
    sqsId: string,
  }).isRequired,
  list: arrayOf(shape({
    id: string,
  })).isRequired,
  onTableRowClick: func.isRequired,
};

export default TableBody;
